import React from 'react';
import { Controller, useForm } from 'react-hook-form';
import ReportFilter, { ReportFilterModel } from './ReportFilter';

type ReportFiltersProps = {
  filters: ReportFilterModel[];
  onSubmit: (data: any) => void;
  formErrors: any;
};

export default function ReportFilters({
  filters,
  onSubmit,
  formErrors,
}: ReportFiltersProps) {
  const {
    control,
    handleSubmit,
    formState: { errors },
  } = useForm({ mode: 'onBlur' });

  return (
    <form onSubmit={handleSubmit(onSubmit)}>
      {filters.map((filter: ReportFilterModel) => (
        <div className='mb-3' key={filter.name}>
          <Controller
            name={filter.name}
            control={control}
            defaultValue={undefined}
            render={({ field }) => (
              <ReportFilter
                filter={filter}
                onChange={(selectedOption) => field.onChange(selectedOption)}
                errorMessage={formErrors[filter.name] ?? ''}
              />
            )}
          />
        </div>
      ))}
      <button type='submit' className='btn btn-primary'>
        Filtrar
      </button>
    </form>
  );
}
